import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const savedToken = Cookies.get("AuthToken");
  const [token, setToken] = useState(savedToken);
  const navigate = useNavigate();

  const logout = () => {
    Cookies.remove("AuthToken");
    setToken(null);
    navigate("/");
  };

  useEffect(() => {
    const handleTokenChange = () => {
      setToken(Cookies.get("AuthToken"));
    };

    window.addEventListener("cookieChange", handleTokenChange);

    return () => {
      window.removeEventListener("cookieChange", handleTokenChange);
    };
  }, []);

  console.log(token, "form auth provider ");

  return (
    <AuthContext.Provider value={{ token, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
